<ham-modal
    *ngIf="previewData || jobStatus"
    [title]="'aumico_companies_bulk_create_financial_year_modal_title' | i18next"
    [cancelText]="'aumico_button_cancel' | i18next"
    [saveText]="'aumico_companies_bulk_create_financial_year_confirm' | i18next"
    [showCancelButton]="!isProcessing"
    [disabled]="loading || (readyGroups.length === 0 && attentionGroups.length === 0)"
    [size]="'lg'"
    (cancel)="onCancel()"
    (save)="onConfirm()"
>
    <!-- Processing View -->
    <div *ngIf="isProcessing && jobStatus" class="bulk-create-processing">
        <div class="processing-header">
            <div class="spinner-container">
                <div class="spinner"></div>
            </div>
            <h3>{{ 'aumico_companies_bulk_create_processing' | i18next }}</h3>
            <p class="processing-status">
                {{
                    'aumico_companies_bulk_create_processing_status'
                        | i18next
                            : {
                                  processed: jobStatus.processedCompanies,
                                  total: jobStatus.totalCompanies
                              }
                }}
            </p>
        </div>

        <!-- Progress Bar -->
        <div class="progress-bar-container">
            <div class="progress-bar">
                <div class="progress-fill" [style.width.%]="progress"></div>
            </div>
            <div class="progress-text">{{ progress }}%</div>
        </div>

        <!-- Current Stats -->
        <div class="processing-stats">
            <div class="stat-item success">
                <span class="ham-icon">
                    <i class="checkmark-circle-outline-icon"></i>
                </span>
                <span class="stat-value">{{ jobStatus.successCount }}</span>
                <span class="stat-label">{{ 'aumico_companies_bulk_create_success_count' | i18next }}</span>
            </div>
            <div class="stat-item error">
                <span class="ham-icon">
                    <i class="close-circle-outline-icon"></i>
                </span>
                <span class="stat-value">{{ jobStatus.failureCount }}</span>
                <span class="stat-label">{{ 'aumico_companies_bulk_create_failure_count' | i18next }}</span>
            </div>
        </div>
    </div>

    <!-- Preview View -->
    <div *ngIf="showPreview && previewData" class="bulk-create-preview">
        <div class="preview-summary">
            <p class="summary-text">
                {{
                    'aumico_companies_bulk_create_financial_year_summary'
                        | i18next
                            : {
                                  ready: previewData.readyCount,
                                  attention: previewData.attentionCount,
                                  skip: previewData.skipCount
                              }
                }}
            </p>
        </div>

        <!-- Ready Group -->
        <div *ngIf="readyGroups.length > 0" class="preview-section ready-section">
            <h3 class="section-header">
                <span class="ham-icon success">
                    <i class="checkmark-circle-outline-icon"></i>
                </span>
                {{ 'aumico_companies_bulk_create_ready' | i18next }}
            </h3>
            <div *ngFor="let group of readyGroups" class="year-group">
                <div class="year-header">
                    <strong>{{ 'aumico_companies_bulk_create_creating_year' | i18next : { year: group.year } }}</strong>
                    <span class="count-badge"
                        >{{ group.count }} {{ 'aumico_companies_bulk_create_clients' | i18next }}</span
                    >
                </div>
                <div class="preview-list">
                    <div *ngFor="let preview of group.previews" class="preview-item">
                        <div class="company-name-row">
                            <span class="company-name">{{ preview.companyName }}</span>
                            <span class="company-label-badge" *ngIf="preview.companyLabel">
                                {{ preview.companyLabel }}
                            </span>
                        </div>
                        <div class="date-range">
                            {{ preview.nextProjectStartDate | dateLocale }} -
                            {{ preview.nextProjectEndDate | dateLocale }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Attention Group -->
        <div *ngIf="attentionGroups.length > 0" class="preview-section attention-section">
            <h3 class="section-header">
                <span class="ham-icon warning">
                    <i class="alert-circle-outline-icon"></i>
                </span>
                {{ 'aumico_companies_bulk_create_attention' | i18next }}
            </h3>
            <div *ngFor="let group of attentionGroups" class="year-group">
                <div class="year-header">
                    <strong>{{ 'aumico_companies_bulk_create_creating_year' | i18next : { year: group.year } }}</strong>
                    <span class="count-badge"
                        >{{ group.count }} {{ 'aumico_companies_bulk_create_clients' | i18next }}</span
                    >
                </div>
                <div class="preview-list">
                    <div *ngFor="let preview of group.previews" class="preview-item">
                        <div class="company-name-row">
                            <span class="company-name">{{ preview.companyName }}</span>
                            <span class="company-label-badge" *ngIf="preview.companyLabel">
                                {{ preview.companyLabel }}
                            </span>
                        </div>
                        <div class="date-range">
                            {{ preview.nextProjectStartDate | dateLocale }} -
                            {{ preview.nextProjectEndDate | dateLocale }}
                        </div>
                        <div *ngIf="preview.reason" class="reason">{{ getLocalizedReason(preview) }}</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Skip Group -->
        <div *ngIf="skipPreviews.length > 0" class="preview-section skip-section">
            <h3 class="section-header">
                <span class="ham-icon error">
                    <i class="close-circle-outline-icon"></i>
                </span>
                {{ 'aumico_companies_bulk_create_skipped' | i18next }}
            </h3>
            <div class="preview-list">
                <div
                    *ngFor="let preview of skipPreviews"
                    class="preview-item"
                    data-testid="next-year-skipped"
                    [attr.data-reason]="getLocalizedReason(preview)"
                >
                    <div class="company-name-row">
                        <span class="company-name">{{ preview.companyName }}</span>
                        <span class="company-label-badge" *ngIf="preview.companyLabel">
                            {{ preview.companyLabel }}
                        </span>
                    </div>
                    <div class="reason error-text">{{ getLocalizedReason(preview) }}</div>
                </div>
            </div>
        </div>
    </div>
</ham-modal>
